import React, { Component } from "react";
import "./layouts.css";
import classNames from "classnames";

export const Sidebar = (props) => {
  const { className, sidebarRight, sidebarLeft, style } = props;
  return (
    <div className={className} style={style}>
      <div className="sidebar left">{sidebarLeft}</div>
      {sidebarRight && <div className="sidebar right">{sidebarRight}</div>}
    </div>
  );
};

export const SideBar = ({ children, className, style }) => {
  return (
    <div className={className} style={style}>
      {children}
    </div>
  );
};

export const SidebarLeft = ({ children }) => (
  <div className="sidebar left">{children}</div>
);

export const SidebarRight = ({ children }) => (
  <div className="sidebar right">{children}</div>
);

export const SidebarHeader = (props) => {
  const { children, style } = props;
  return (
    <div className="area_of titles" style={style}>
      {children}
    </div>
  );
};

export const SidebarViewAll = (props) => {
  const { ViewAllClassName, viewAll } = props;
  return (
    <div className={classNames("area_of view_all", ViewAllClassName)}>
      {viewAll}
    </div>
  );
};

export const SideBarButtons = (props) => {
  const { children, classNameWrapper } = props;
  return <div className={classNameWrapper}>{children}</div>;
};
